import React from "react";
import { showDate } from "../../constant";

function FeeRecordTable({data,paymentType}) {
    let total = data.total_fee
    let paiedfee = 0 ;

    for (let i = 0; i < data?.feeRecord.length; i++) {
        paiedfee += data?.feeRecord[i].total_amount
    }

  return (
    <div className="mt-5">
      <div className="flex items-center">
        <p className="font-medium">Fees Collection</p>
      </div>

      <div className="mt-3 space-y-3">
        <div className="bg-white border border-gray-100 rounded-lg shadow-md">
          <div className="px-4 py-5 sm:p-6">
            <div className="grid grid-cols-4 gap-5 md:grid-cols-6">
              <div className="col-span-1 md:col-span-1 md:order-1">
                <p className="text-sm text-gray-600">Total Fees</p>
                <p className="mt-1 text-lg leading-tight text-primary-600">
                  {total}
                </p>
              </div>
              <div className="col-span-1 md:col-span-1 md:order-1">
                <p className="text-sm text-gray-600">Remaining Fees</p>
                <p className="mt-1 text-lg leading-tight text-primary-600">
                  {total - paiedfee}
                </p>
              </div>
              <div className="col-span-1 md:col-span-1 md:order-1">
                <p className="text-sm text-gray-600">Installments</p>
                <p className="mt-1 text-lg leading-tight text-primary-600">
                  {data.no_of_installments}
                </p>
              </div>
            </div>

            <table className="custom-table mt-5">
              <thead className="">
                <tr>
                  <th scope="col">Payment Type</th>
                  <th scope="col" className="hidden xl:table-cell">
                    Installments
                  </th>
                  <th scope="col" className="hidden sm:table-cell">
                    Paid Fees
                  </th>
                  <th scope="col" className="">
                    Payment Date
                  </th>
                  <th scope="col" className="">
                    Payment Status
                  </th>
                </tr>
              </thead>

              <tbody id="elements-container">
                {data?.feeRecord.map((item, index) => (
                  <tr key={item?._id} className="draggable-element">
                    <td className="font-medium">
                    {paymentType
                            .filter((val) => val._id === item.payment_type)
                            .map((val) => val.type) // Assuming you want to display the type property
                        }
                     {/* {item.payment_type} */}
                    </td>
                    <td className="hidden xl:table-cell whitespace-nowrap">
                      {item.installment}
                    </td>
                    <td className="hidden sm:table-cell whitespace-nowrap">
                      {item?.total_amount}
                    </td>
                    <td>{showDate(item?.payment_date)}</td>
                    <td>Paid</td>
                  </tr>
                ))}
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeeRecordTable;
